import React from "react";
import { Link } from "react-router-dom";
import { getFormattedNumber, getTotal } from "../utils/textUtils";

const SalesByCustomer = ({ resPacket }) => {
  return resPacket?.length > 0 ? (
    <div className="customTable"  id="scroll">
      <table className="customTable w-100">
        <thead className="fixed-thead">
          <tr>
            <td>SNO.</td>
            <td>ORDER DATE</td>
            <td>CUSTOMER NAME</td>
            <td>ORDER NO.</td>
            <td className="text-right">TOTAL AMOUNT</td>
          </tr>
        </thead>
        <tbody className="body-scroll-custom">
          {resPacket &&
            resPacket.map((a, i) => {
              return (
                <tr key={i}>
                  <td>{i+1}</td>
                  <td>{a.salesOrderDate}</td>
                  <td>{a.customerTitle}</td>
                  <td>
                    <Link to={`/salesorders/${a.recordId}`} target="_blank">
                      {a.orderNo}
                    </Link>
                  </td>
                  <td className="text-right">
                    {" "}
                    ₹ {getFormattedNumber(a.totalAmount)}
                  </td>
                </tr>
              );
            })}
          <tr>
            <td>TOTAL:</td>
            <td></td>
            <td></td>
            <td className="text-right">
              ₹ {getFormattedNumber(getTotal(resPacket, "totalAmount"))}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  ) : (
    <>No Record found</>
  );
};

export default SalesByCustomer;